import { jsx, jsxs } from "react/jsx-runtime";
import { ChevronRight, Cloud, Moon, Star, Sun } from "@tamagui/lucide-icons";
import { ListItem, Separator, XStack, YGroup } from "tamagui";
function ListItemDemo() {
  return /* @__PURE__ */ jsxs(XStack, { $sm: { flexDirection: "column" }, paddingHorizontal: "$4", space: true, children: [
    /* @__PURE__ */ jsx(ListItemDemo1, {}),
    /* @__PURE__ */ jsx(ListItemDemo2, {})
  ] });
}
function ListItemDemo1() {
  return /* @__PURE__ */ jsxs(YGroup, { alignSelf: "center", bordered: true, width: 240, size: "$4", children: [
    /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(ListItem, { hoverTheme: true, icon: Star, title: "Star", subTitle: "Twinkles" }) }),
    /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(ListItem, { hoverTheme: true, icon: Moon, children: "Moon" }) }),
    /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(ListItem, { hoverTheme: true, icon: Sun, children: "Sun" }) }),
    /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(ListItem, { hoverTheme: true, icon: Cloud, children: "Cloud" }) })
  ] });
}
function ListItemDemo2() {
  return /* @__PURE__ */ jsxs(YGroup, { alignSelf: "center", bordered: true, width: 240, size: "$5", separator: /* @__PURE__ */ jsx(Separator, {}), children: [
    /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(
      ListItem,
      {
        hoverTheme: true,
        pressTheme: true,
        title: "Star",
        subTitle: "Subtitle",
        icon: Star,
        iconAfter: ChevronRight
      }
    ) }),
    /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(
      ListItem,
      {
        hoverTheme: true,
        pressTheme: true,
        title: "Moon",
        subTitle: "Subtitle",
        icon: Moon,
        iconAfter: ChevronRight
      }
    ) })
  ] });
}
export {
  ListItemDemo
};
//# sourceMappingURL=ListItemDemo.js.map
